import React from 'react'
import { useStyle } from "./Style";
import { Grid } from '@mui/material';

const ClaimSummary = (props) => {
  const classes = useStyle();



  if (!props.claimSummaryData) return (
    <>
      <Grid container spacing={2} className={classes.headingclaim}>
        <Grid item xs={12} sm={12} md={12}>
          <h4>Claim Details</h4>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <p>nothing found yet</p>
        </Grid>
      </Grid>
    </>
  )

  const summaryDetails = props.claimSummaryData.additional_details || {};

  return (
    <>
      <Grid container spacing={2} className={classes.headingclaim}>
        <Grid item xs={12} sm={12} md={12}>
          <h4>Claim Summary</h4>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>

          {
            (props.hasHospiCashIllnessBenefit) ||  (props.hasHospiCashAccidentBenefit)  ? (<>

              <div className={classes.claimDetailsWrapper}>
                <table>
                  <tr>
                    <th>Policy  Number</th>
                    <th>Admission Date</th>
                    <th>Discharge Date</th>
                    <th>Number Of Days In Hospital</th>
                    <th>Hospital Attended</th>
                    <th>Inpatient Number</th>
                    <th>Cause Of Hospitilization</th>
                  </tr>
                  <tr >
                    <td>{props.claimSummaryData.policy_number}</td>
                    <td>{props.claimSummaryData.additional_details.admission_date || "N/A"}</td>
                    <td>{props.claimSummaryData.additional_details.discharge_date || "N/A"}</td>
                    <td>{props.claimSummaryData.additional_details.number_of_days_in_hospital || "N/A"}</td>
                    <td>{props.claimSummaryData.additional_details.hospital_attended || "N/A"}</td>
                    <td>{props.claimSummaryData.additional_details.inpatient_number || "N/A"}</td>
                    <td>{props.claimSummaryData.additional_details.cause_of_hospitilization || "N/A"}</td>
                  </tr>
                </table>


              </div>
            </>) : props.showFuneralDetails || (props.hasFuneralNaturalDeath) || (props.hasFuneralAccidentalDeath) || props.isMalawiFuneralBenefits ? (<>

              <div className={classes.claimDetailsWrapper}>
                <table>
                  <tr>
                    <th>Policy  Number</th>
                    <th>Date Of Death</th>
                    <th>Cause Of Death</th>
                    <th>Funeral Home</th>
                    <th>Death Certificate Number</th>
                  </tr>
                  <tr >
                    <td>{props.claimSummaryData.policy_number}</td>
                    <td>{props.claimSummaryData.event_date || "N/A"}</td>
                    <td>{summaryDetails.cause_of_death || "N/A"}</td>
                    <td>{summaryDetails.funeral_home_name || "N/A"}</td>
                    <td>{summaryDetails.death_certficate_number || "N/A"}</td>
                  </tr>
                </table>


              </div>


            </>) : props.hasAccidentalDeathBenefit || props.hasNaturalDeathBenefit ?
            (<div className={classes.claimDetailsWrapper}>
              <table>
                <tr>

                  <th>Policy  Number</th>
                  <th>Date Of Death</th>

                </tr>
                <tr >
                  <td>{props.claimSummaryData.policy_number}</td>
                  <td>{props.claimSummaryData.event_date || "N/A"}</td>
                </tr>
              </table>
            
            </div>) 
            : props.hasPartialPermanentDisabilityBenefit || props.hasTotalPermanentDisabilityBenefit ?
             (<div className={classes.claimDetailsWrapper}>
              <table>
                <tr>
    
                  <th>Policy  Number</th>
                  <th>Date Of Disability</th>
        
                </tr>
                <tr >
                  <td>{props.claimSummaryData.policy_number}</td>
                  <td>{props.claimSummaryData.event_date || "N/A"}</td>
                </tr>
              </table>
             


            </div>) :
             (<>

              <div className={classes.claimDetailsWrapper}>
                <table>
                  <tr>
                    <th>Policy  Number</th>
                    <th>Admission Date</th>
                    <th>Discharge Date</th>
                    <th>Number of Days in Hospital</th>
                    <th>Hospital Attended</th>
                    <th>Inpatient Number</th>
                    <th>Type of Cancer</th>
                  </tr>
                  <tr >
                    <td>{props.claimSummaryData.policy_number}</td>
                    <td>{props.claimSummaryData.additional_details.admission_date || "N/A"}</td>
                    <td>{props.claimSummaryData.additional_details.discharge_date || "N/A" }</td>
                    <td>{props.claimSummaryData.additional_details.number_of_days_in_hospital || "N/A" }</td>
                    <td>{props.claimSummaryData.additional_details.hospital_attended || "N/A" }</td>
                    <td>{props.claimSummaryData.additional_details.inpatient_number || "N/A"}</td>
                    <td>{props.claimSummaryData.additional_details.type_of_cancer || "N/A" }</td>
                  </tr>
                </table>


              </div>
            
            
            
            </>)
          }


        </Grid>
      </Grid>
    </>
  )
}

export default ClaimSummary